export const maskMemberCode = (code) => {
  if (!code) return '';
  if (code.length <= 10) return code;
  return `${code.slice(0, 5)}${'*'.repeat(code.length - 10)}${code.slice(-5)}`;
};

export default maskMemberCode;
